import React, { useState, useEffect, useMemo } from 'react';
import { Accordion, Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { isEmpty } from 'lodash';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SystemMasterSelect } from '../../Components/helper';
import Loader from '../../Components/Utility/Loader/Loader';
import BtnAdd from '../../Components/Utility/FilterAction/BtnAdd';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import { toasterMsg } from '../../Components/Toaster/Toaster';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';

const newTempObj = () => ({
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
  aliasName: '',
  _cid: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
});

function Category4Master() {
  const dispatch = useDispatch();
  const history = useHistory();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { category1List, category2List } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingCat4, setIsLoadingCat4] = useState(false);
  const [showCat4, setShowCat4] = useState(false);
  const [isCategory4Unique, setIsCategory4Unique] = useState(true);
  const [buttonDownCat4, setButtonDownCat4] = useState(true);
  const [cat4BtnDisable, setCat4BtnDisable] = useState(false);
  const [addingCat4, setAddingCat4] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isCat4, setIsCat4] = useState(false);
  const [cat4Data, setCat4Data] = useState([]);
  const [category3List, setCategory3List] = useState([]);
  const [category4List, setCategory4List] = useState([]);
  const [isUniqCat4Id, setIsUniqCat4Id] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [scrollEl, setScrollEl] = useState();
  const [category4first, setCategory4first] = useState({});
  const [category4second, setCategory4second] = useState({});
  const [category4third, setCategory4third] = useState({});
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'category', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'category', 'delete');
  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  // Check if selected Category 3 is active
  const isCategory3Active = useMemo(() => {
    if (!category4third?._id) return true; // Allow operations when no Category 3 is selected

    // Find the actual Category 3 item from the list to check its current active status
    const actualCat3Item = category3List?.find((cat3) => cat3._id === category4third._id);
    if (!actualCat3Item) return false;

    return actualCat3Item.isActive === true;
  }, [category4third, category3List]);

  // Fetch CatBasedOnPT flag (controls whether Cat2 depends on Cat1)
  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      const catBasedOnPTRes = await dispatch(action.getCatBasedOnPT());
      setCatBasedOnPTData(catBasedOnPTRes);
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  useEffect(() => {
    if (isEmpty(category4third)) {
      setCat4Data([]);
      return;
    }
    setCat4Data(category4List);
    if (addingCat4) {
      setCat4Data([...category4List, newTempObj()]);
    }
  }, [category4List, addingCat4, category4third]);

  /**
   * Category 3 is scoped to a Category 1 + Category 2 pair, so a refreshed list for a new pair
   * never contains the previously chosen entry. Drop the selection once it is no longer on
   * offer, and keep it when the refreshed list still carries it.
   */
  useEffect(() => {
    if (isEmpty(category4third?._id)) {
      return;
    }
    const isStillAvailable = (category3List || []).some((cat3) => cat3?._id === category4third._id);
    if (!isStillAvailable) {
      setCategory4third({});
      setAddingCat4(false);
      setIsUniqCat4Id([]);
      setIsCategory4Unique(true);
      setCat4BtnDisable(false);
    }
  }, [category3List, category4third]);

  const callApi = async () => {
    setButtonDownCat4(!buttonDownCat4);
    setIsLoadingCat4(true);
    if (buttonDownCat4) {
      setShowCat4(true);

      const cat4firstParams = {
        accessedFrom: 'masters',
        categoryType: 1,
        loggedInUserId,
      };

      const cat4seconParams = {
        accessedFrom: 'masters',
        categoryType: 2,
        loggedInUserId,
      };

      if (isEmpty(cat4Data)) {
        isEmpty(category1List) && (await dispatch(action.getCategory1Details(cat4firstParams)));
        isEmpty(category2List) && (await dispatch(action.getCategory2Details(cat4seconParams)));
      }
    } else {
      // Closing accordion - clear all state
      setShowCat4(false);
      setCategory4first({});
      setCategory4second({});
      setCategory4third({});
      setCategory3List([]);
      setCategory4List([]);
      setCat4Data([]);
      setAddingCat4(false);
      setIsUniqCat4Id([]);
      setIsCategory4Unique(true);
      setCat4BtnDisable(false);
      setDeleteId('');
      setActiveInactiveID('');
      setShowConfirmation(false);
      setShowConfirmationAD(false);
      setIsCat4(false);
    }
    setIsLoadingCat4(false);
  };

  const handleChanged = (event, i) => {
    // Prevent changes if Category 3 is selected and inactive
    if (category4third?._id && !isCategory3Active) {
      return;
    }

    const categories4 = [...cat4Data];
    if (event.target.name === 'aliasName') {
      categories4[i] = {
        ...categories4[i],
        aliasName: event.target.value,
      };
    } else {
      categories4[i] = {
        ...categories4[i],
        name: event.target.value,
        isEmpty: event.target.value === '',
      };
    }
    setIsCategory4Unique(true);
    setIsUniqCat4Id([]);
    const array = [];
    const arrayIndex = [];
    categories4.forEach((ele, ind) => {
      categories4.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          array.push(ele);
          arrayIndex.push(index);
        }
      });
    });
    if (!isEmpty(array)) {
      const arrs = [...arrayIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrayIndex.filter((ele) => ele !== removeArss);
      setIsUniqCat4Id([...newArr]);
    }
    setIsCategory4Unique(isEmpty(array));
    let disableCat4 = false;
    categories4.forEach((category4Element) => {
      if (isEmpty(category4Element?.name?.trim())) {
        disableCat4 = true;
      }
    });
    setCat4BtnDisable(disableCat4);
    setCat4Data(categories4);
  };

  const handleDelete = (id) => {
    // Prevent deletion if Category 3 is selected and inactive
    if (category4third?._id && !isCategory3Active) {
      toasterMsg('Cannot delete Category 4 items. Selected Category 3 is inactive. Please activate Category 3 first.', 'danger');
      return;
    }

    if (typeof id === 'number' || id === '') {
      cat4Data.splice(id, 1);
      cat4Data.forEach((category4Element) => {
        if (isEmpty(category4Element?.name?.trim()) && category4Element.isNew) {
          setCat4BtnDisable(true);
        } else {
          setCat4BtnDisable(false);
        }
      });
      setIsUniqCat4Id([]);
      setIsCategory4Unique(true);
      setCat4Data([...cat4Data]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  useEffect(() => {
    Object.keys(category4first).length !== 0 && Object.keys(category4second).length !== 0 && Object.keys(category4third).length !== 0 && category4Called();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category4first, category4second, category4third]);

  const category4Called = async () => {
    const cat4params = {
      categoryOneId: category4first._id,
      categoryTwoId: category4second._id,
      categoryThreeId: category4third._id,
      categoryType: 4,
      loggedInUserId,
    };
    setCategory4List(await dispatch(action.getCategoryListForMasterCard(cat4params)));
  };

  const saveCat4 = async () => {
    setIsCat4(true);

    // Prevent saving if Category 3 is selected and inactive
    if (category4third?._id && !isCategory3Active) {
      toasterMsg('Cannot save Category 4 items. Selected Category 3 is inactive. Please activate Category 3 first.', 'danger');
      setIsCat4(false);
      return;
    }

    if (!isEmpty(cat4Data)) {
      const emptyField = await cat4Data.filter((c4item) => c4item.name === null || c4item.name === '');

      if (isEmpty(emptyField)) {
        const data = cat4Data.map(({ _cid, ...ca4obj }) => ({
          ...ca4obj,
          name: ca4obj?.name?.trim(),
          aliasName: ca4obj?.aliasName?.trim(),
        }));
        const cat4params = {
          loggedInUserId,
          categoriesName: JSON.stringify(data),
          categoryType: 4,
          title: t('CATEGORY4_MASTER.CATEGORIESS'),
          categoryOneId: category4first._id,
          categoryTwoId: category4second._id,
          categoryThreeId: category4third._id,
        };
        setAddingCat4(false);
        await dispatch(action.saveToSystemMaster(cat4params, t));
        await category4Called();
        // post API
      } else {
        const newState = cat4Data.map((ca4obj) => (ca4obj?.isEmpty === false && ca4obj.name === null ? { ...ca4obj, isEmpty: true } : ca4obj));
        setCat4Data(newState);
      }
    }
    setIsCat4(false);
  };

  useEffect(() => {
    const array = [];
    cat4Data.forEach((ele, index) => {
      cat4Data.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsCategory4Unique(isEmpty(array));
      setIsUniqCat4Id([]);
    }
  }, [cat4Data]);

  const activeInactiveClicked = (id) => {
    // Prevent active/inactive changes if Category 3 is selected and inactive
    if (category4third?._id && !isCategory3Active) {
      toasterMsg('Cannot change Category 4 status. Selected Category 3 is inactive. Please activate Category 3 first.', 'danger');
      return;
    }

    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const category4Params = {
      loggedInUserId,
      wantToDeleteCategoryId: deleteId,
      categoryType: 4,
      categoryOneId: category4first._id,
      categoryTwoId: category4second._id,
      categoryThreeId: category4third._id,
      title: t('CATEGORY4_MASTER.CATEGORIES'),
    };
    await dispatch(action.deleteFromSystemMasters(category4Params, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setCat4Data([...category4List]);
    await category4Called();
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let c4 = {};
    cat4Data.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: t('CATEGORY4_MASTER.CATEGORIES'),
        };
        c4 = data;
      }
    });
    await dispatch(action.setActiveInactive(c4, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setCat4Data([...cat4Data]);
  };

  const addCat4 = async () => {
    // Prevent adding if Category 3 is selected and inactive
    if (category4third?._id && !isCategory3Active) {
      toasterMsg('Cannot add new Category 4 items. Selected Category 3 is inactive. Please activate Category 3 first.', 'danger');
      return;
    }

    if (!showCat4) {
      setAddingCat4(true);
      setButtonDownCat4(!buttonDownCat4);
      setIsLoadingCat4(true);
      buttonDownCat4 ? setShowCat4(true) : setShowCat4(false);
      const cat4firstParams = {
        accessedFrom: 'masters',
        categoryType: 1,
        loggedInUserId,
      };
      const cat4seconParams = {
        accessedFrom: 'masters',
        categoryType: 2,
        loggedInUserId,
      };
      !showCat4 && (await dispatch(action.getCategory1Details(cat4firstParams))) && (await dispatch(action.getCategory2Details(cat4seconParams)));
      setIsLoadingCat4(false);
    } else if (!isEmpty(cat4Data)) {
      setCat4Data([...cat4Data, newTempObj()]);
    } else {
      setCat4Data([newTempObj()]);
    }
  };

  useEffect(() => {
    if (Object.keys(category4first).length !== 0 && Object.keys(category4second).length !== 0) {
      category3forCat4Called();
    } else {
      setCategory3List([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category4first, category4second]);

  const category3forCat4Called = async () => {
    const cat3params = {
      categoryOneId: category4first._id,
      categoryTwoId: category4second._id,
      categoryType: 3,
      loggedInUserId,
    };
    setCategory3List(await dispatch(action.getCategoryListForMasterCard(cat3params)));
  };

  /**
   * Reloads the Category 3 options each time the dropdown opens, so an entry added, deactivated or
   * deleted in the Category 3 card since the pair was chosen shows up here without re-selecting it.
   */
  const refreshCategory3Options = () => {
    if (!isEmpty(category4first) && !isEmpty(category4second)) {
      category3forCat4Called();
    }
  };

  const btnCall = () => {
    if (buttonDownCat4 === false) {
      return <i className="icon-new-up" />;
    }
    return <i className="icon-new-down" />;
  };

  const renderTooltipOpenCloseCat4 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!buttonDownCat4 ? t('CATEGORY4_MASTER.TOOLTIP_CLOSE') : t('CATEGORY4_MASTER.TOOLTIP_OPEN')}
    </Tooltip>
  );

  const renderTooltipActiveInactive = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('CATEGORY4_MASTER.ACTIVATE_INACTIVATE')}
    </Tooltip>
  );

  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('CATEGORY4_MASTER.DELETE')}
    </Tooltip>
  );

  const handleDropdownChange = (value, fromName) => {
    switch (value.type) {
      case 1:
        if (showCat4 && fromName === 'category4first') {
          setCategory4first(value);
          // Reset downstream selections when upstream changes
          if (catBasedOnPTData) {
            setCategory4second({});
            setCategory4third({});
          }
        }
        break;
      case 2:
        if (showCat4 && fromName === 'category4second') {
          setCategory4second(value);
        }
        break;
      case 3:
        showCat4 && fromName === 'category4third' && setCategory4third(value);
        break;
      default:
        history.push({
          pathname: '/masters',
          state: null,
        });
        break;
    }
  };

  // Compute Category 2 options based on selected Category 1 when the flag is ON
  const filteredCategory2Options = useMemo(() => {
    if (!catBasedOnPTData) return category2List || [];
    const selectedCat1Id = category4first?._id;
    if (!selectedCat1Id) return [];
    return (category2List || []).filter((c2) => Array.isArray(c2?.catOneIds) && c2.catOneIds.includes(selectedCat1Id));
  }, [catBasedOnPTData, category2List, category4first]);

  const cat4Save = () => {
    return isCat4 ? (
      <Spinner animation="border" />
    ) : (
      <>
        <span className="icon-Save c-button-align f-20 mr-2" /> {t('CATEGORY4_MASTER.SAVE')}
      </>
    );
  };

  return (
    <>
      <Accordion className="mb-4 master-accordian">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('CATEGORY4_MASTER.TITLE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              <BtnAdd
                onBtnClick={addCat4}
                forDisable={cat4BtnDisable || !isCategory4Unique || (category4third?._id && !isCategory3Active)}
                addEditAccess={MasterAddEditAccess}
              />
              <OverlayTrigger placement={t('CATEGORY4_MASTER.AUTO')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenCloseCat4}>
                <button type="button" onClick={() => callApi()}>
                  {btnCall()}
                </button>
              </OverlayTrigger>
            </div>
          </Card.Header>
          {showCat4 &&
            (isLoadingCat4 ? (
              <Loader />
            ) : (
              <Card.Body>
                <div className="select-container">
                  <Select
                    options={category1List}
                    placeholder={t('CATEGORY4_MASTER.SELECT_CATEGORY1')}
                    getOptionLabel={(option) => `${option?.name}`}
                    getOptionValue={(option) => `${option?._id}`}
                    name="category4first"
                    value={Object.keys(category4first).length !== 0 && category4first}
                    styles={SystemMasterSelect}
                    onChange={(e) => handleDropdownChange(e, 'category4first')}
                    // isDisabled={isDisable}
                  />
                  <Select
                    options={filteredCategory2Options}
                    placeholder={t('CATEGORY4_MASTER.SELECT_CATEGORY2')}
                    getOptionLabel={(option) => `${option?.name}`}
                    getOptionValue={(option) => `${option?._id}`}
                    name="category4second"
                    isDisabled={!Object.keys(category4first).length}
                    value={Object.keys(category4second).length !== 0 && category4second}
                    styles={SystemMasterSelect}
                    onChange={(e) => handleDropdownChange(e, 'category4second')}
                  />
                  <Select
                    options={category3List}
                    placeholder={t('CATEGORY4_MASTER.SELECT_CATEGORY3')}
                    getOptionLabel={(option) => `${option?.name}`}
                    getOptionValue={(option) => `${option?._id}`}
                    name="category4third"
                    isDisabled={!Object.keys(category4first).length && !Object.keys(category4second).length}
                    value={Object.keys(category4third).length !== 0 && category4third}
                    styles={SystemMasterSelect}
                    onMenuOpen={refreshCategory3Options}
                    onChange={(e) => handleDropdownChange(e, 'category4third')}
                  />
                </div>
                <PerfectScrollbar
                  containerRef={(ref) => {
                    setScrollEl(ref);
                  }}
                >
                  <ul>
                    {Object.keys(category4first).length !== 0 &&
                      Object.keys(category4second).length !== 0 && // change here
                      Object.keys(category4third).length !== 0 && // change here
                      !isEmpty(cat4Data) &&
                      cat4Data.map((object4, index4) => {
                        return (
                          <li key={object4?._id || object4?._cid || `new-${index4}`}>
                            <input
                              name="aliasName"
                              maxLength={5}
                              value={cat4Data[index4]?.aliasName || ''}
                              onChange={(e) => handleChanged(e, index4)}
                              className="w-50px mr-2"
                              disabled={!MasterAddEditAccess || (category4third?._id && !isCategory3Active)}
                            />
                            <div className="input-container">
                              <input
                                name="category4"
                                value={object4.name ? object4.name : ''}
                                placeholder={t('CATEGORY4_MASTER.ENTER_CATEGORY4')}
                                maxLength={30}
                                type="text"
                                disabled={!MasterAddEditAccess || (category4third?._id && !isCategory3Active)}
                                autoFocus={!object4._id}
                                onChange={(e) => handleChanged(e, index4)}
                              />
                              {!isEmpty(isUniqCat4Id) && isUniqCat4Id.includes(index4) && (
                                <label className="text-danger m-0 p-1">{t('CATEGORY4_MASTER.ENTRY_ALREADY_EXIST')}</label>
                              )}

                              {object4.isEmpty && (object4.name === null || object4.name === '') && (
                                <label className="text-danger m-0 p-1">{t('CATEGORY4_MASTER.REQUIRED_ENTRY')}</label>
                              )}
                              {object4.isNew && !isEmpty(object4.name) && isEmpty(object4?.name?.trim()) && (
                                <label className="text-danger m-0 p-1">{t('CATEGORY4_MASTER.INVALID_ENTRY')}</label>
                              )}
                            </div>
                            <div className="input-action">
                              {object4._id !== '' && MasterAddEditAccess && (
                                <OverlayTrigger placement={t('CATEGORY4_MASTER.AUTO')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
                                  <button aria-label="active" type="button" onClick={() => activeInactiveClicked(object4._id)} id={object4._id}>
                                    <span className={object4.isActive ? 'icon-active' : 'icon-inactive'} />
                                  </button>
                                </OverlayTrigger>
                              )}
                              {MasterDeleteAccess && (
                                <OverlayTrigger placement={t('CATEGORY4_MASTER.AUTOS')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
                                  <button
                                    aria-label="delete"
                                    type="button"
                                    onClick={() => {
                                      handleDelete(object4._id ? object4._id : index4);
                                    }}
                                  >
                                    <span className="icon-delete mt-3 f-20" />
                                  </button>
                                </OverlayTrigger>
                              )}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </PerfectScrollbar>
                <div className="section-save">
                  {MasterAddEditAccess && (
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button
                        aria-label="Save"
                        type="button"
                        className="btn btn-page-filter btn-white"
                        onClick={saveCat4}
                        disabled={cat4BtnDisable || !isCategory4Unique || (category4third?._id && !isCategory3Active)}
                      >
                        {cat4Save()}
                      </button>
                    </CustomTooltip>
                  )}
                </div>
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('CATEGORY4_MASTER.CONFIRM_DELETE_TITLE')}
          message={t('CATEGORY4_MASTER.CONFIRM_DELETE_MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('CATEGORY4_MASTER.CONFIRM_ACTIVATE_DEACTIVATE_TITLE')}
          message={t('CATEGORY4_MASTER.CONFIRM_ACTIVATE_DEACTIVATE_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default Category4Master;
